import React, { useEffect } from "react";
import { FlaskConical } from "lucide-react";
import { useAuth } from "../../lib/auth-context";
import { useUpdatePostponed } from "../../lib/pwa";

import { useTranslation } from "react-i18next";

/** Same strip as the other banners: one row, so the app header always clears it. */
const BANNER_HEIGHT = "2.5rem";

/**
 * Shown on every screen of a demonstration club (admin, coach, student alike): the
 * club's people are invented, so nobody should type a real name or a child's details
 * into it. No action of its own, and one row per screen: it leaves the strip to the
 * strips that carry one (impersonation, break-glass access, an available update).
 */
export function DemoBanner() {
  const { t } = useTranslation("common");
  const { user } = useAuth();
  const postponed = useUpdatePostponed();
  const busyElsewhere = !!user?.impersonator || !!user?.accessGrant || postponed;
  const showing = !!user?.club?.isDemo && !busyElsewhere;

  // The app header and sticky page bars sit below the strip: they read its height from --banner-h.
  useEffect(() => {
    if (!showing) return;
    const root = document.documentElement;
    root.style.setProperty("--banner-h", BANNER_HEIGHT);
    return () => {
      root.style.removeProperty("--banner-h");
    };
  }, [showing]);

  if (!showing) return null;

  return (
    <div
      className="sticky top-0 z-40 flex items-center gap-2 bg-warning px-3 text-sm font-medium text-warning-foreground sm:justify-center sm:gap-3 sm:px-4"
      style={{ height: BANNER_HEIGHT }}
      role="status"
      aria-live="polite"
    >
      <FlaskConical className="h-4 w-4 shrink-0" aria-hidden />
      <span className="min-w-0 truncate sm:hidden">{t("demoBanner.short")}</span>
      <span className="hidden min-w-0 truncate font-normal sm:inline">{t("demoBanner.text")}</span>
    </div>
  );
}
